// import action types
import { UPDATE_CHECKOUT_STATE, CLEAR_CHECKOUT_STATE } from 'constants/redux-events';

/********************************************************/

/**
 * @type {function}
 * @desc A Redux Reducer to manage state of the Redux Store
 * @param {object} [state={}] - Current state of the Redux Store at given state key
 * @param {object} action - Redux **action** object with **event name** and **payload**
 * @example
 * import { checkoutState } from 'reducers/checkoutState';
 */
export const checkoutState = ( state = {}, action ) => {
    const { type, payload } = action;

    switch( type ) {

        case UPDATE_CHECKOUT_STATE:
            return payload;

        case CLEAR_CHECKOUT_STATE:
            return {  };

        default:
            return state;
    }
};
